"use client";

import { useSession } from "next-auth/react";
import { ReactNode } from "react";

interface SessionUser {
  isDesignClient?: boolean;
}

interface LeadModalControllerWrapperProps {
  children: ReactNode;
  testMode?: boolean;
}

/**
 * Client-side wrapper that checks session to determine if the lead capture
 * modal should be shown. Design clients should not see lead capture modals.
 *
 * Usage: Wrap the server-side LeadModalController with this wrapper in the layout.
 * This allows the server component to be passed through (as children) rather than
 * being imported inside a client component.
 */
export function LeadModalControllerWrapper({
  children,
  testMode,
}: LeadModalControllerWrapperProps) {
  const { data: session, status } = useSession();

  if (!testMode) {
    // Don't render anything while session is loading
    if (status === "loading") {
      return null;
    }

    // Don't show lead capture modal to design clients
    const user = session?.user as SessionUser | undefined;
    if (user?.isDesignClient) {
      return null;
    }
  }

  return <>{children}</>;
}

export default LeadModalControllerWrapper;
